import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'brToNewLine'
})
export class BrToNewLinePipe implements PipeTransform {

  constructor() {}

  transform(str:string): string {
    return str.replace(/<br\s*\/?>/g, '\n');
  }

}
